/* eslint no-shadow: ["error", { "allow": ["state"] }]	*/
import Vue from 'vue';
import Vuex from 'vuex';
import VueSession from 'vue-session';

const options = {
	persist: true
};

Vue.use(Vuex);
Vue.use(VueSession, options);

const state = {
    isSidebarOpen: false
};

const getters = {
    getSidebarStatus: (state) => {
        return state.isSidebarOpen;
    }
};

const mutations = {
    resetSidebar: (state) => {
        state.isSidebarOpen = false;
    },
    toggleSidebar: (state) => {
        state.isSidebarOpen = !state.isSidebarOpen;
    }
 };

export default {
    state,
    getters,
    mutations
};